module.exports = __webpack_public_path__ + "static/media/Mulish-Light.1f6c59e7.ttf";